import { Networked3dWebExperienceClient } from "@mml-io/3d-web-experience-client";
import {
  CanvasTexture,
  FrontSide,
  Group,
  LinearMipMapLinearFilter,
  Mesh,
  MeshStandardMaterial,
  NearestFilter,
  PlaneGeometry,
  RepeatWrapping,
  Texture,
} from "three";

import hdrJpgUrl from "../../../assets/hdr/puresky_2k.jpg";
import airAnimationFileUrl from "../../../assets/models/anim_air.glb";
import doubleJumpAnimationFileUrl from "../../../assets/models/anim_double_jump.glb";
import idleAnimationFileUrl from "../../../assets/models/anim_idle.glb";
import jogAnimationFileUrl from "../../../assets/models/anim_jog.glb";
import sprintAnimationFileUrl from "../../../assets/models/anim_run.glb";

const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
const host = window.location.host;
const userNetworkAddress = `${protocol}//${host}/network`;
const chatNetworkAddress = `${protocol}//${host}/chat-network`;
const blockHeight = window.location.hostname.split('.')[0];
const bitmap = window.BITMAP_DATA


const holder = Networked3dWebExperienceClient.createFullscreenHolder();
const app = new Networked3dWebExperienceClient(holder, {
  sessionToken: (window as any).SESSION_TOKEN,
  userNetworkAddress,
  chatNetworkAddress,
  animationConfig: {
    airAnimationFileUrl,
    idleAnimationFileUrl,
    jogAnimationFileUrl,
    sprintAnimationFileUrl,
    doubleJumpAnimationFileUrl,
  },
  mmlDocuments: { example: { url: `${protocol}//${host}/mml-documents/example-mml.html` } },
  environmentConfiguration: {
    groundPlane: {
      size: bitmap.width * 19 - 3 + 6
    },
    skybox: {
      hdrJpgUrl: hdrJpgUrl//'../../../assets/hdr/puresky_whiteroom.jpg'
    },
  },
  avatarConfiguration: {
    allowCustomAvatars: true,
    availableAvatars: [],
  },
  blockHeight
});

// const floorGeometry = new PlaneGeometry(5, 5, 1, 1);
// const floorMaterial = new MeshStandardMaterial({
//     color: 0xffffff,
//     side: FrontSide,
//     metalness: 0.05,
//     roughness: 0.95,
//   });
// const floorMesh = new Mesh(floorGeometry, floorMaterial);
// floorMesh.receiveShadow = true;
// floorMesh.rotation.x = Math.PI * -0.5;
// floorMesh.position.y = 0.21
// app.scene.add(floorMesh);
// app.mmlCompositionScene.mmlScene.addCollider(floorMesh)
// console.log('-------------ADD TO SCENE---------------',window.location.host)

// Generate a grid to easily know where each parcel is located.
let gridData = []
for(let y=0; y<bitmap.width; y++) {
  gridData.push([])
  for(let x=0; x<bitmap.width; x++) {
    gridData[y].push([])
  }
}

// Loop through each parcel
for(let i=0; i<bitmap.txns.length; i++) {
  const parcel = bitmap.txns[i]
  const size = parcel.size*bitmap.columnSize - bitmap.streetSize
  const sizeHalf = size/2
  const xPos = parcel.x*bitmap.columnSize + sizeHalf
  const yPos = parcel.y*bitmap.columnSize + sizeHalf

  const frameElement = document.createElement('m-frame')
  frameElement.setAttribute('id',i)
  frameElement.setAttribute('size',size)
  frameElement.setAttribute('x',xPos - bitmap.gridWidthHalf)
  frameElement.setAttribute('y',0.2)// height of orange parcel cube
  frameElement.setAttribute('z',yPos - bitmap.gridWidthHalf)
  frameElement.setAttribute('load-range',100)
  frameElement.setAttribute('unload-range',0)
  frameElement.setAttribute('min-x',-sizeHalf)
  frameElement.setAttribute('max-x',sizeHalf)
  frameElement.setAttribute('min-y',-0.2)// makes sure parcel cube is visible
  frameElement.setAttribute('max-y',size)
  frameElement.setAttribute('min-z',-sizeHalf)
  frameElement.setAttribute('max-z',sizeHalf)
  //frameElement.setAttribute('src', 'wss://run.mmleditor.com/ckq05K');
  frameElement.setAttribute('src', `${protocol}//${host}/mml-documents/parcel-${i}.html`);

  // const parcelElement = document.createElement('m-cube')
  // parcelElement.setAttribute('width',size)
  // parcelElement.setAttribute('height',0.2)
  // parcelElement.setAttribute('depth',size)
  // parcelElement.setAttribute('y',-0.1)
  // // const parcelElement = document.createElement('m-image')
  // // parcelElement.setAttribute('width',size)
  // // parcelElement.setAttribute('height',size)
  // // parcelElement.setAttribute('rx',-90)
  // // parcelElement.setAttribute('y',0.01)
  // parcelElement.setAttribute('color','#d5790e')
  // frameElement.appendChild(parcelElement);

  document.body.appendChild(frameElement);
  //console.log('-------------ADD TO MML---------------',document)

  // Place frame in grid
  const cellTop = Math.floor((yPos-sizeHalf)/bitmap.columnSize)
  const cellBot = Math.floor((yPos+sizeHalf)/bitmap.columnSize)
  const cellLeft = Math.floor((xPos-sizeHalf)/bitmap.columnSize)
  const cellRight = Math.floor((xPos+sizeHalf)/bitmap.columnSize)
  for(let y=cellTop; y<=cellTop + (cellBot-cellTop); y++) {
    for(let x=cellLeft; x<=cellLeft + (cellRight-cellLeft); x++) {
      // Register m-frame into grid cell
      if(y>=0 && y<gridData.length && x>=0 && x<gridData[y].length)
        gridData[y][x].push(frameElement)
    }
  }
}

// Cache grid data
window.GRID_DATA = gridData


app.update();
